import React, {useEffect} from 'react';
import failed from './symbols/failed.svg';
import pending from './symbols/pending.svg';
import running from './symbols/running.svg';
import success from './symbols/success.svg';
import {readableDate} from '../../../../../../universal/utils';

const MaintenanceCommand = (props) => {

  let status;
  const comment = props.command[0];
  const date = new Date(props.curCommand.RequestedDateTime);
  const size = '50';

  const commandDate = new Date(props.curCommand.RequestedDateTime);
  const hoursSince = (Date.now() - commandDate) / (1000 * 60 * 60);
  const timeThreshold = 24;

  const commandTimes = props.curCommands.map(curCommand => {
    return {
      date: readableDate(new Date(curCommand.RequestedDateTime)),
      status: curCommand.Status
    };
  });

  if (props.curCommand.Status === 'InProgress') status = 'running';
  else if (hoursSince > timeThreshold) status = 'pending';
  else if (props.curCommand.Status === 'Success') status = 'success';
  else status = 'failed';

  const Image = () => {
    const images = {failed, pending, running, success};
    return <img src={images[status]} height={size} width={size}/>;
  };

  return (
    <div className={`MaintenanceCommandPage MaintenanceCommandPage-${status}`}>
      <p>{status[0].toUpperCase() + status.slice(1)}</p>
      <Image/>
      <p>{comment || '*No Comment*'}</p>
      {/* <p>{readableDate(date)}</p> */}
      {commandTimes.map(command => {
        return <p style={{fontSize: 10}} key={command.date}>{command.date} - {command.status}</p>;
      })}
    </div>
  );

};

MaintenanceCommand.propTypes = {

};

export default MaintenanceCommand;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/maintenanceMonitor/maintenanceCommand/maintenanceCommand.js